import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Card = ({ name, address, role, imageUrl, propertyId }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <StyledCard>
        {/* Imagen */}
        <motion.img
          src={imageUrl}
          alt={name}
          className="property-image"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        />

        {/* Información */}
        <div className="card-content">
          <h3>{name}</h3>
          <p className="subtitle">{address}</p>
        </div>

        {/* Botones */}
        <div className="buttons">
          <motion.button
            className="btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(`/devices/${propertyId}`)}
          >
            Dispositivos
          </motion.button>
          {role === 'owner' && (
            <motion.button
              className="btn btn-edit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Editar
            </motion.button>
          )}
          {(role === 'owner' || role === 'admin') && (
            <motion.button
              className="btn btn-guests"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(`/guests/${propertyId}`)}
            >
              Huéspedes
            </motion.button>
          )}
        </div>
      </StyledCard>
    </motion.div>
  );
};

const StyledCard = styled.div`
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  width: 300px;
  margin: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  .property-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }

  .subtitle {
    font-size: 0.8rem !important;
    color: #777;
    margin-bottom: 15px;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    .btn {
      padding: 10px;
      font-size: 1rem;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      transition: background-color 0.3s ease;
      width: 100%;
    }

    .btn:hover {
      opacity: 0.9;
    }

    .btn:first-child {
      background-color: teal;
    }

    .btn-edit {
      background-color: #f4a261;
    }

    .btn-guests {
      background-color: #2a9d8f;
    }
  }
`;

export default Card;